export default function endpointsFactory(route = '') {
  const API_PREFIX = route ? `parcelamentos-mei/${route}` : 'parcelamentos-mei'

  return {
    paged: (page, pageSize) => `${API_PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`,
    parcelas: parcelamentoId => `${API_PREFIX}/${parcelamentoId}/parcelas`,
    parcelasRecentes: parcelamentoId => `${API_PREFIX}/${parcelamentoId}/parcelas-recentes`,
    guiaParcela: (parcelamentoId, parcelaId) => (parcelaId ? `${API_PREFIX}/${parcelamentoId}/guia/${parcelaId}` : `${API_PREFIX}/${parcelamentoId}/guia`),
    baixaLotes: nomeArquivo => `${API_PREFIX}/baixa-lotes?nomeArquivo=${nomeArquivo}`,
    enviarNotifica: id => `${API_PREFIX}/${id}/notifica`,
    enviarNotificaParcela: (id, parcelaId) => `${API_PREFIX}/${id}/parcela/${parcelaId}/notifica`,
    observacoes: id => `${API_PREFIX}/${id}/observacao`,
    removerObservacao: id => `${API_PREFIX}/observacao/${id}/remover`,
    salvarObservacao: `${API_PREFIX}/observacao/salvar`,
    baixarSelecionadas: `${API_PREFIX}/baixar-selecionadas`,
    baixarEmExcelEspecifico: `${API_PREFIX}/baixa-excel-selecionados`,
    docWhatsapp: id => `${API_PREFIX}/${id}/url-whatsapp`,
  }
}
